"use strict";
(self["webpackChunkFirmSupport"] = self["webpackChunkFirmSupport"] || []).push([[755],{

/***/ 20755:
/***/ ((module) => {

module.exports = JSON.parse('{"welcomeToFirmSupport":"A warm welcome to Lundify Workflow","loginToContinue":"Log in to continue!","login":"Log in","loggingInPleaseWait":"Logging in, please wait...","loginFooter":"email: info.se@bjornlunden.com | phone: 0650-54 14 00","expiredSessionTitle":"Expired session","expiredSessionDescription":"The login is too old/invalid. Please log in again to continue.","inactiveUserTitle":"Deactivated user","inactiveUserDescription":"Your user account has been deactivated. Please contact a firm administrator to reactivate your account.","youAreBeingLoggedInPleaseWait":"You are being logged in, please wait..."}');

/***/ })

}]);